import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { organizationOptionsShape, ParameterTypes, partnerShape, siteShape, TemplateTypes } from '../types';
import GeoRestrictions from './GeoRestrictions';
import { GET_COUNTRIES } from '../../queries';
import { Spinner } from '../../../components/widgets';
import UserDataSharingRestrictions from './UserDataSharingRestrictions';
import { getTemplate, getUsedPrivacyParameters } from './utils';

function AdvancedSettings({ partner, site, isReadonly = false, isUserAdmin = false, orgOptions }) {
    const { geoRestrictionsSupported = false, ldsSupported = false } = orgOptions;
    const countriesResponse = useQuery(GET_COUNTRIES, { skip: !geoRestrictionsSupported });
    const partnerPrivacyParameters = getUsedPrivacyParameters(
        partner,
        site.platform,
        getTemplate(partner, site.platform, TemplateTypes.INSTALL) ? TemplateTypes.INSTALL : TemplateTypes.CUSTOM,
        [ParameterTypes.ACCOUNT, ParameterTypes.APPLICATION]
    );

    if (geoRestrictionsSupported && countriesResponse.loading) return <Spinner show expanded />;

    return (
        <>
            {(ldsSupported || partnerPrivacyParameters.length > 0) && (
                <UserDataSharingRestrictions
                    partner={partner}
                    partnerPrivacyParameters={partnerPrivacyParameters}
                    ldsSupported={ldsSupported}
                    isReadonly={isReadonly || isUserAdmin}
                />
            )}
            {geoRestrictionsSupported && (
                <GeoRestrictions
                    partner={partner}
                    countries={countriesResponse.data?.countries || []}
                    isReadonly={isReadonly}
                />
            )}
        </>
    );
}

AdvancedSettings.propTypes = {
    partner: partnerShape.isRequired,
    site: siteShape.isRequired,
    orgOptions: organizationOptionsShape.isRequired,
    isReadonly: PropTypes.bool,
    isUserAdmin: PropTypes.bool,
};

export default AdvancedSettings;
